// # #############################################
// # Title : Radio Button
// # Authors : Atul, Anoop, Yashu, Smit, Sameer, Mahesh, Dhruv, Shubham
// # Date : 15th October 2019
// # Last Modified : Shubham, September 2019
// # Version : 19.10.03
// # Description : This is the code for rendering the simulation setting options on the create scenarion window
// # ############################################


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import '../css/App.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tab from '@material-ui/core/Tab';
import "../css/simSettingLayout.css";
import Rating from 'react-rating';
// import DateIcon from '@material-ui/icons/DateRange';
import ReactTooltip from "react-tooltip";

const StyledRating = withStyles({
    iconFilled: {
        color: '#3ca0b0',
    },
    iconHover: {
        color: '#3ca0b0',
    },
})(Rating);


function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const Handle = Slider.Handle;

const MyTab = withStyles(theme => ({
    root: {
        backgroundColor: "#ccc51",
        borderRadius: theme.shape.borderRadius,
        color: "black"
    },

    selected: {
        color: 'rgb(0, 167, 189)',
        borderBottom: '2px solid rgb(0, 167, 189)',
        fontSize: "1.6vh"
    }
}))(Tab);

const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Tooltip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
        >
            <Handle value={value} {...restProps} />
        </Tooltip>
    );
};

const styles = theme => ({
    root: {
        display: 'flex',
        width: "100%",
        height: "100%",
        // background:'#D2DBE0'
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
    },
    expansionPanel: {
        width: "100%",
        // background:'#D2DBE0'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    accordionItem: {
        margin: "0 20%",
        width: "60%"
    },
    sliderLabel: {
        fontSize: "0.7vw",
        color: "rgba(0, 0, 0, 0.54)"
    },
    radio: {
        '&$checked': {
            color: '#344955'
        }
    },
    checked: {},
    simDuration: {
        width: "100%"
    },
    agentSliderLabel: {
        fontSize: "15px"
    }
});

class SimSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            uniqueId: (new Date()).getTime(),
            modelType: "Individual",
            panelExpanded: "agents_ticks",
            noOfCompetitors: sessionStorage.getItem("noOfCompetitors") ? parseInt(sessionStorage.getItem("noOfCompetitors")) : 3,
            tabIndex: 0,
            dataToSend: {
                "simParameters": {
                    "n_agents": [
                        200
                    ],
                    "n_ticks": [
                        120
                    ],
                    "startTimeStamp": [
                        ""
                    ]
                },
                "levelZeroParameters": {
                    "model_type": [
                        "Individual"
                    ],
                    "individualThresholds": {
                        "eat_hunger": [
                            7
                        ],
                        "eat_energy": [
                            2
                        ],
                        "drink_thirst": [
                            6
                        ],
                        "drink_energy": [
                            3
                        ]
                    },
                    "combinedThresholds": {
                        "hunger_wt": [
                            0.7
                        ],
                        "thirst_wt": [
                            0.7
                        ],
                        "energy_hunger_wt": [
                            0.3
                        ],
                        "energy_thirst_wt": [
                            0.3
                        ],
                        "eat_hunger_energy": [
                            5
                        ],
                        "drink_thirst_energy": [
                            5
                        ]
                    },
                    "commonThresholds": {
                        "hunger_seed": [
                            6
                        ],
                        "energy_seed": [
                            7
                        ],
                        "fatigue_seed": [
                            6.5
                        ],
                        "thirst_seed": [
                            5
                        ],
                        "sd_seed": [
                            0.3
                        ],
                        "sleep_fatigue_high": [
                            6
                        ],
                        "sleep_fatigue_low": [
                            3.5
                        ],
                        "sleep_lumens": [
                            0.2
                        ]
                    }
                },
                "productParameters": {
                    "Product_attributes": [
                        {
                            "brandName": "yourBrand",
                            "competitorBrand": false,
                            "health": 5,
                            "taste": 2,
                            "pleasure": 1,
                            "visualAppeal": 4,
                            "price": 6
                        }
                    ],
                    "beveragecategory": [
                        "Water"
                    ]
                },
                "simStatus": {
                    "stopSimFlag": false
                }
            },
            accordians: [
                {
                    label: "Agents & Hours",
                    id: "agents_ticks",
                    visibleIn: "both",
                    content: [
                        {
                            visibleIn: "both",
                            label: "Number of agents",
                            destination: "simParameters.n_agents",
                            minValue: 5000,
                            maxValue: 20000,
                            selectedValue: sessionStorage.getItem("no_of_agents") ? sessionStorage.getItem("no_of_agents") : 5000,
                            step: 1
                        },
                        {
                            visibleIn: "both",
                            label: "Hours",
                            destination: "simParameters.n_ticks",
                            minValue: 24,
                            maxValue: 240,
                            selectedValue: 504,
                            step: 1
                        },
                        {
                            visibleIn: "both",
                            label: "Start Date",
                            destination: "simParameters.startTimeStamp",
                            selectedValue: new Date(2018, 0, 1),
                            step: 1
                        },
                        {
                            visibleIn: "both",
                            label: "End Date",
                            // destination: "simParameters.endTimeStamp",
                            selectedValue: new Date(2018, 0, 22),
                            step: 1
                        }
                    ]
                },
                {
                    label: "Eat",
                    id: "eat",
                    visibleIn: "both",
                    content: [
                        {
                            visibleIn: "individual",
                            label: "Hunger",
                            destination: "levelZeroParameters.individualThresholds.eat_hunger",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 7,
                            step: 1
                        },
                        {
                            visibleIn: "individual",
                            label: "Energy",
                            destination: "levelZeroParameters.individualThresholds.eat_energy",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 2,
                            step: 1
                        },
                        {
                            visibleIn: "combined",
                            label: "Hunger-Energy",
                            destination: "levelZeroParameters.combinedThresholds.eat_hunger_energy",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 5,
                            step: 1
                        }
                    ]
                },
                {
                    label: "Drink",
                    id: "drink",
                    visibleIn: "both",
                    content: [
                        {
                            visibleIn: "individual",
                            label: "Thirst",
                            destination: "levelZeroParameters.individualThresholds.drink_thirst",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 6,
                            step: 1
                        },
                        {
                            visibleIn: "individual",
                            label: "Energy",
                            destination: "levelZeroParameters.individualThresholds.drink_energy",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 1,
                            step: 1
                        },
                        {
                            visibleIn: "combined",
                            label: "Thirst-Energy",
                            destination: "levelZeroParameters.combinedThresholds.drink_thirst_energy",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 5,
                            step: 1
                        }
                    ]
                },
                {
                    label: "Sleep",
                    id: "sleep",
                    visibleIn: "both",
                    content: [
                        {
                            visibleIn: "both",
                            label: "Fatigue - Induce Sleep",
                            destination: "levelZeroParameters.commonThresholds.sleep_fatigue_high",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 6,
                            step: 1
                        },
                        {
                            visibleIn: "both",
                            label: "Fatigue - Induce wakeup",
                            destination: "levelZeroParameters.commonThresholds.sleep_fatigue_low",
                            minValue: 1,
                            maxValue: 10,
                            selectedValue: 4,
                            step: 1
                        },
                        {
                            visibleIn: "both",
                            label: "Lumens",
                            destination: "levelZeroParameters.commonThresholds.sleep_lumens",
                            minValue: 0,
                            maxValue: 1,
                            selectedValue: 0.2,
                            step: 0.1
                        }
                    ]
                },

                {
                    label: "Weights",
                    id: "weights",
                    visibleIn: "combined",
                    content: [
                        {
                            visibleIn: "combined",
                            label: "Hunger",
                            destination: "levelZeroParameters.combinedThresholds.hunger_wt",
                            minValue: 0,
                            maxValue: 1,
                            selectedValue: 0.7,
                            step: 0.1
                        },
                        {
                            visibleIn: "combined",
                            label: "Thirst",
                            destination: "levelZeroParameters.combinedThresholds.thirst_wt",
                            minValue: 0,
                            maxValue: 1,
                            selectedValue: 0.7,
                            step: 0.1
                        },
                        {
                            visibleIn: "combined",
                            label: "Hunger-Energy Weight",
                            destination: "levelZeroParameters.combinedThresholds.energy_hunger_wt",
                            minValue: 0,
                            maxValue: 1,
                            selectedValue: 0.3,
                            step: 0.1
                        },
                        {
                            visibleIn: "combined",
                            label: "Thirst-Energy Weight",
                            destination: "levelZeroParameters.combinedThresholds.energy_thirst_wt",
                            minValue: 0,
                            maxValue: 1,
                            selectedValue: 0.3,
                            step: 0.1
                        }
                    ]
                }
            ]
        }
    }

    componentDidUpdate(){
        sessionStorage.setItem("noOfCompetitors", this.state.noOfCompetitors)
    }

    componentDidMount() {
        const self = this;

        sessionStorage.setItem("noOfCompetitors", self.state.noOfCompetitors)
        if (sessionStorage.getItem("simSettings")) {
            self.setState(JSON.parse(sessionStorage.getItem("simSettings")));
        } else {
            sessionStorage.setItem("simSettings", JSON.stringify(this.state));
        }
    }

    handleChangeEx = (_, activeIndex) => this.setState({ activeIndex })


    customSetState = (ob) => {
        const self = this;
        sessionStorage.setItem("simSettings", JSON.stringify(Object.assign(self.state, ob)));
        self.setState(ob);
    };

    handleChangeOfModel = (el) => {
        const self = this;

        if (self.state.modelType !== el) {
            self.setState({
                modelType: el,
                tabIndex: 0
            });
        }
    };

    handleChangeOfTab = (el) => {
        const self = this;
        self.setState({
            tabIndex: el
        });
    };

    handleChange = (accordianObject, sliderOb, newVal) => {
        const self = this;
        const allAccordians = self.state.accordians.map(acc => {
            if (acc.id === accordianObject.id) {
                acc.content = acc.content.map(sOb => {
                    if (sOb.label === sliderOb.label) {
                        sOb.selectedValue = newVal;
                    }
                    return sOb;
                });
            }
            return acc;
        });
        if (sliderOb.label === 'Agents') {
            sessionStorage.setItem('TotalAgents', newVal)
        }

        if (sliderOb.label === "Number of agents") {
            sessionStorage.setItem('no_of_agents', sliderOb.selectedValue)
        }

        this.customSetState({ accordians: allAccordians });
    };

    handleSimTimeInput = (accordianObject, sliderOb, value) => {
        const newVal = new Date(value);
        const self = this;
        const allAccordians = self.state.accordians.map(acc => {
            if (acc.id === accordianObject.id) {
                acc.content = acc.content.map(sOb => {
                    if (sOb.label === sliderOb.label) {
                        sOb.selectedValue = newVal;
                    }
                    return sOb;
                });
            }
            return acc;
        });

        if (accordianObject.content[2].selectedValue && accordianObject.content[3].selectedValue) {
            // set number of ticks
            let endDate = typeof accordianObject.content[3].selectedValue === 'string' ? new Date(accordianObject.content[3].selectedValue) : accordianObject.content[3].selectedValue;
            let startDate = typeof accordianObject.content[2].selectedValue === 'string' ? new Date(accordianObject.content[2].selectedValue) : accordianObject.content[2].selectedValue;
            let oneDay = 24 * 60 * 60 * 1000;
            let diffDays = Math.round(Math.abs((endDate.getTime() - startDate.getTime()) / (oneDay)));
            let numberOfTicks = parseInt(diffDays) * 24;
            allAccordians[0].content[1].selectedValue = numberOfTicks
        }

        if (sliderOb.label === 'Agents') {
            sessionStorage.setItem('TotalAgents', newVal)
        }

        this.customSetState({ accordians: allAccordians })
    };

    panelExpand = panel => (event, expanded) => {
        this.customSetState({
            panelExpanded: expanded ? panel : false,
        });
    };

    getSlider = (accordianObject, sliderOb, classes, xs) => {
        const self = this;

        return (
            <Grid item xs={xs} className={classes.accordionItem}>
                <div style={{ width: "140%", marginLeft: "-20%", paddingTop: "5%", display: 'flex', flexDirection: 'column' }}>
                    {sliderOb.label === "Number of agents" ? null : <div style={{
                        marginTop: '5%', marginBottom: '5%', width: '100%',
                        fontSize: "1.5vh"
                    }} className={classes.sliderLabel}>{sliderOb.label + " : " + sliderOb.selectedValue}</div>}
                    <Slider
                        min={sliderOb.minValue}
                        max={sliderOb.maxValue}
                        step={sliderOb.step}
                        defaultValue={sliderOb.selectedValue}
                        handle={handle}
                        sliderOb={sliderOb}
                        onChange={(newVal) => {
                            self.handleChange(accordianObject, sliderOb, newVal);
                        }}
                    />
                </div>
            </Grid>
        );
    };

    getRating = (tabIndex, accordianObject, sliderOb, classes, xs) => {
        const self = this;
        const behaviour = ["Eat", "Drink", "Sleep", "Weights"];

        return (
            <div className="threshold-selection">
                <div data-tip data-for={behaviour[tabIndex] + sliderOb.label} className="threshold-selection-labels">{sliderOb.label}</div>
                <StyledRating
                    placeholderRating={sliderOb.selectedValue}
                    step={sliderOb.step}
                    // fractions={2}
                    placeholderSymbol={<svg width="1rem" height="1rem"><circle fill="#3ca0b0" stroke="#c1c1c1" cx="0.3rem" cy="0.3rem" r="0.3rem" /></svg>}
                    emptySymbol={<svg width="1rem" height="1rem"><circle fill="white" stroke="#c1c1c1" cx="0.3rem" cy="0.3rem" r="0.3rem" /></svg>}
                    fullSymbol={<svg width="1rem" height="1rem"><circle fill="#3ca0b0" stroke="#c1c1c1" cx="0.3rem" cy="0.3rem" r="0.3rem" /></svg>}
                    stop={sliderOb.maxValue}
                    // onHover={(rate) => document.getElementById('label-onrate').innerHTML = rate || ''}
                    onChange={(newVal) => {
                        self.handleChange(accordianObject, sliderOb, newVal);
                    }}
                />
                <div className="threshold-rating-value">{sliderOb.step === 1 ? sliderOb.selectedValue : sliderOb.selectedValue.toFixed(1)}</div>
            </div>
        );
    };

    getTabHeaders = (tabObject, index) => {
        // const self = this;
        return (
            <MyTab label={tabObject.label}
                style={{ fontSize: "1.6vh" }}
                {...a11yProps(index)} />
        );
    }

    getTabContent = (tabIndex, metadata, classes) => {
        const self = this;
        return (
            <div className="tab-content" >
                <Typography
                    component="div"
                    role="tabpanel"
                    hidden={false}
                    id={`full-width-tabpanel-${tabIndex}`}
                    aria-labelledby={`full-width-tab-${tabIndex}`}
                    style={{ width: "100%", fontSize: "0.5rem" }}
                >
                    {metadata.content.map(sliderOb => {
                        if (sliderOb.visibleIn === "both" || sliderOb.visibleIn === self.state.modelType.toLowerCase()) {
                            return (self.getRating(tabIndex, metadata, sliderOb, classes));
                        } else {
                            return null;
                        }
                    })}
                </Typography>
            </div>

        )
    }

    getToolTips() {

        return (
            <div>
                <ReactTooltip
                    class='individual'
                    id='individual'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select to set individual threshold values to trigger certain agent behaviour
                        </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='combined'
                    id='combined'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select to set the weights for the linear combination for the threshold values to trigger certain agent behaviour
                        </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='noOfAgents'
                    id='noOfAgents'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Population for the simulation
                        </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='dateRange'
                    id='dateRange'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select duration for the simulation
                    </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='threshold'
                    id='threshold'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select method to trigger agent behaviour
                    </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='eat'
                    id='eat'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select threshold to trigger eating behaviour for the agents
                    </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='drink'
                    id='drink'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select threshold to trigger drinking behaviour for the agents
                    </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
                <ReactTooltip
                    class='sleep'
                    id='sleep'
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            Select threshold to trigger sleeping behaviour for the agents
                    </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
            </div>

        )
    }

    getToolTips2(mainLabel, innerLabel, modelType) {
        const toolTipContent = "Set " + innerLabel + " threshold to " + mainLabel;
        if (mainLabel === "Weights") {
            return null;
        }
        else {
            return (
                <ReactTooltip
                    class={mainLabel + innerLabel}
                    id={mainLabel + innerLabel}
                    getContent={dataTip => (
                        <div className="tooltip-style">
                            {toolTipContent}
                        </div>
                    )}
                    effect='solid'
                    place={"top"}
                    border={true}
                    type={"light"}
                />
            )
        }
    }

    changeNoOfCompetitor(operation){

        const noOfComp = this.state.noOfCompetitors

        if(operation === "reduce" && noOfComp-1 >= 2){
            this.setState({
                noOfCompetitors: noOfComp-1
            })
        }
        else if(operation === "add" && noOfComp+1 <= 5){
            this.setState({
                noOfCompetitors: noOfComp+1
            })
        }
        else{
            this.props.showNotification("Number of Competitors should range from 2 to 5", { variant: "error" });
        }
    }

    render() {
        const self = this;
        const { classes } = this.props;
        const { accordians, tabIndex, modelType } = this.state;

        let startDateToDisplay = (accordians[0].content[2].selectedValue).toString();
        let endDateToDisplay = (accordians[0].content[3].selectedValue).toString();

        startDateToDisplay = new Date(startDateToDisplay).setFullYear(2020);
        endDateToDisplay = new Date(endDateToDisplay).setFullYear(2020);

        return (

            <div className="productView">
                {this.getToolTips()}
                {
                    accordians[tabIndex + 1].content.map(i => {
                        if (i.visibleIn === modelType.toLowerCase() || i.visibleIn === "both") {
                            return (this.getToolTips2(accordians[tabIndex + 1].label, i.label, modelType.toLowerCase()));
                        }
                        else {
                            return null
                        }
                    })
                }
                <div class="rows">
                    <div className="left">
                        <div className="main-header">Basic</div>
                        <div className="section1" style={{ "padding-bottom": "0%" }}>
                            <div className="agents-container">
                                <div data-tip data-for='noOfAgents' className="content-label"> Number of Agents </div>
                                <text className="agents">{accordians[0].content[0].selectedValue}</text>
                            </div>
                            <div className="agent-slider">
                                {(self.getSlider(accordians[0], accordians[0].content[0], classes))}
                            </div>
                        </div>
                        <div className="section1dot2">
                            <div className="competitor-container">
                                <div data-tip data-for='competitor' className="content-label"> Number of Competitors </div>
                                <div className="competitor-lever">
                                    <input
                                        type='button'
                                        onClick={this.changeNoOfCompetitor.bind(this, "reduce")}
                                        value='-'
                                        className='minus'
                                    />
                                    <text className="competitors">{self.state.noOfCompetitors}</text>
                                    <input
                                        type='button'
                                        onClick={this.changeNoOfCompetitor.bind(this, "add")}
                                        value='+'
                                        className='plus'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="section2">
                            <div data-tip data-for='dateRange' className="content-label"> Select a Date Range</div>
                            <div className="date-selection-table">
                                <div className="date-selection">
                                    <div>From</div>
                                    <div className="date1">
                                        <DatePicker
                                            selectsStart
                                            className='datePickerStyles'
                                            selected={startDateToDisplay}
                                            onChange={(date) => this.handleSimTimeInput(accordians[0], accordians[0].content[2], new Date(date).setFullYear(2018))}
                                            style={{ width: '5vw' }}
                                            minDate={new Date(2020, 0)}
                                            maxDate={new Date(2020, 11, 31)}
                                        />
                                    </div>
                                    {/* <DateIcon className="date-icon" /> */}
                                </div>
                                <div className="date-selection">
                                    <div>To</div>
                                    <div className="date2">
                                        <DatePicker
                                            selectsEnd
                                            className='datePickerStyles'
                                            selected={endDateToDisplay}
                                            onChange={(date) => this.handleSimTimeInput(accordians[0], accordians[0].content[3], new Date(date).setFullYear(2018))}
                                            minDate={new Date(2020, 0)}
                                            maxDate={new Date(2020, 11, 31)}
                                        />
                                    </div>
                                    {/* <DateIcon className="date-icon" /> */}
                                </div>

                            </div>
                            <div className="date-summary-label">
                                <text className="date-summary-label-text">
                                    Selected Duration
                                    <text className="date-summary">
                                        {(this.state.accordians[0].content[1].selectedValue === 0) ? '' : (((parseInt(this.state.accordians[0].content[1].selectedValue)) / 24) + ' days')}
                                    </text>
                                </text>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="main-header">Advanced</div>
                        <div className="section1">
                            <div data-tip data-for='threshold' className="content-label"> Select Thresholding Type </div>
                            <div className="toggle-button">
                                <div className={(self.state.modelType === "Individual") ? "toggle-button1-selected" : "toggle-button1"} ref="Individual" onClick={this.handleChangeOfModel.bind(this, "Individual")}>
                                    <div data-tip data-for='individual' className="toggle-text">Individual</div>
                                </div>
                                <div className={(self.state.modelType === "Combined") ? "toggle-button2-selected" : "toggle-button2"} ref="Combined" onClick={this.handleChangeOfModel.bind(this, "Combined")}>
                                    <div data-tip data-for='combined' className="toggle-text">Combined</div>
                                </div>
                                <h2>{this.state.category_selected}</h2>
                            </div>
                        </div>
                        <div className="section2">
                            <div className="categories">
                                <div className={self.state.tabIndex === 0 ? "card_selected_element" : "card_element"} ref="eat" onClick={this.handleChangeOfTab.bind(this, 0)} >
                                    <div data-tip data-for='eat' className="text_container"> Eat </div>
                                </div>
                                <div className={self.state.tabIndex === 1 ? "card_selected_element" : "card_element"} ref="drink" onClick={this.handleChangeOfTab.bind(this, 1)}  >
                                    <div data-tip data-for='drink' className="text_container"> Drink </div>
                                </div>
                                <div className={self.state.tabIndex === 2 ? "card_selected_element" : "card_element"} ref="sleep" onClick={this.handleChangeOfTab.bind(this, 2)}>
                                    <div data-tip data-for='sleep' className="text_container"> Sleep </div>
                                </div>
                                {
                                    (self.state.modelType === 'Combined') ?
                                        (
                                            <div className={self.state.tabIndex === 3 ? "card_selected_element" : "card_element"} ref="weights" onClick={this.handleChangeOfTab.bind(this, 3)}>
                                                <div data-tip data-for='Weights' className="text_container"> Weights </div>
                                                <ReactTooltip
                                                    class='Weights'
                                                    id='Weights'
                                                    getContent={dataTip => (
                                                        <div className="tooltip-style">
                                                            Weights to be used for the combined threshold
                                                        </div>
                                                    )}
                                                    effect='solid'
                                                    place={"top"}
                                                    border={true}
                                                    type={"light"}
                                                />
                                            </div>
                                        ) : null
                                }

                            </div>
                            <div className="moment-rating">
                                {self.getTabContent(tabIndex, accordians.slice(1)[tabIndex], classes)}
                                <text id='label-onrate'></text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

SimSettings.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimSettings);
